import React, {Component} from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import moment from "moment/moment";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {reactLocalStorage as Storage} from "reactjs-localstorage";
import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';
import {
  FormGroup,
  FormSelect,
  FormInput,
  Button, Col, Row,
  Card, CardBody,
  Badge,
  Modal,
  ModalHeader,
  ModalBody
} from "shards-react";
import './style.scss'
import ModalLoading from "../../../components/common/ModalLoading";

@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me }))
@inject(({ review }) => ({ getSnsFeed:review.getSnsFeed, registerSnsFeedsToReview: review.registerSnsFeedsToReview, fetchAndUploadSnsFeed: review.fetchAndUploadSnsFeed, uploadSnsFeedImages: review.uploadSnsFeedImages }))
@inject(({ common }) => ({ getSnsConnections: common.getSnsConnections }))
@inject(({ product }) => ({ getProductList: product.getProductList }))

@observer
class SnsFeed extends Component {

  //basic
  @observable store = {};
  @observable teamUser = {};
  @observable isLogin = false;
  @observable isLoading = true;
  @observable isFetching = false;
  @observable isUploading = false;

  //page
  @observable selectedSns = 'instagram'; // SNS 플랫폼 선택 (instagram, facebook 등)
  @observable activeTab = 'myFeed'; // 'myFeed' or 'taggedFeed'
  @observable searchFormValue = {
    sns: 'all',
    keyword: '',
    isHidden: 'all'
  };

  // SNS 연동 상태 (SnsSetting과 동일한 구조)
  @observable snsData = {
    instagram: {
      connected: false,
      username: "",
      userId: "",
      connectedAt: null
    },
    facebook: {
      connected: false,
      pageName: "",
      pageId: "",
      connectedAt: null
    },
    naver: {
      connected: false,
      blogId: "",
      blogName: "",
      connectedAt: null
    },
    youtube: {
      connected: false,
      channelName: "",
      channelId: "",
      connectedAt: null
    }
  };

  @observable listParams = {
    page: 1,
    limit: 20,
    sort: 'createdAt',
    order: 'desc'
  };

  // 체크박스 선택
  @observable selectedItems = [];
  @observable isAllSelected = false;

  // 피드 상세 모달
  @observable showMediaModal = false;
  @observable selectedMedia = null;

  // 상품 선택 모달
  @observable showProductModal = false;
  @observable reviewDateEnabled = false;
  @observable reviewDate = moment().format('YYYY-MM-DD');
  @observable reviewDefaultContent = '인스타그램에서 작성된 리뷰 입니다.';
  @observable reviewSnsLabel = '인스타그램에서 작성된 리뷰 입니다.';
  @observable reviewSnsLabelEnabled = true;
  @observable reviewProductScore = 5;
  @observable reviewDeliveryScore = 5;
  @observable productList = {
    docs: [],
    totalDocs: 0,
    page: 1,
    totalPages: 1,
    limit: 20
  };
  @observable productSearchParams = {
    keyword: '',
    page: 1,
    limit: 20
  };

  @observable list = {
    docs: [],
    totalDocs: 0,
    page: 1,
    totalPages: 1
  };

  @observable nextCursor = null;
  @observable hasNextPage = false;

  componentDidMount() {
    this.init();
  }

  @action
  init = async () => {
    if(this.props.isLogin) {
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.store = this.props.me.store ? this.props.me.store : {};

      // localStorage에서 limit 값 가져오기
      this.listParams.limit = parseInt(await Storage.get('limitSnsFeed')) || this.listParams.limit;

      // SNS 연동 상태 로드
      await this.loadSnsConnections();

      await this.doSearch();
    }
  };

  @action
  loadSnsConnections = async () => {
    try {
      const params = {
        store_id: this.store._id,
        shopNo: this.teamUser.selShopNo,
      };

      // GraphQL 쿼리로 SNS 연동 정보 가져오기
      await this.props.getSnsConnections(params, (res) => {
        console.log('SNS Connections:', res);
        if(res && res.data) {
          this.snsData = res.data;
        }
      });
    } catch (error) {
      console.error('SNS 연동 정보 로드 실패:', error);
    }
  };

  @action
  changeSns = async (sns) => {
    this.selectedSns = sns;
    this.listParams.page = 1;
    this.nextCursor = null;
    this.hasNextPage = false;
    this.activeTab = 'myFeed'; // SNS 변경 시 기본 탭으로 리셋
    await this.doSearch();
  };

  // 개별 피드의 이미지가 카페24에 저장되지 않았는지 확인
  isNotUploadedItem = (item) => {
    if (!item.media || !Array.isArray(item.media) || item.media.length === 0) return false;
    return item.media.some(m => {
      if (!m.url || m.type === 'video') return false;
      return !m.url.includes('/web/upload/') && !m.url.includes('NNEditor');
    });
  };

  // 카페24에 업로드되지 않은 이미지가 있는 피드 목록
  getUnuploadedFeeds = () => {
    if (!this.list || !this.list.docs) return [];
    return this.list.docs.filter(item => this.isNotUploadedItem(item));
  };

  @action
  uploadFeedImages = async () => {
    if (this.isUploading) return;
    const unuploaded = this.getUnuploadedFeeds();
    if (unuploaded.length === 0) {
      toast.info('업로드할 이미지가 없습니다.');
      return;
    }
    this.isUploading = true;
    try {
      const params = {
        store_id: this.store._id,
        shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
        snsFeed_Ids: unuploaded.map(item => item._id || item.id),
      };
      await this.props.uploadSnsFeedImages(params, (res) => {
        if (res && res.data && res.data.success) {
          toast.success(res.data.message);
          this.doSearch();
        } else {
          toast.error('이미지 업로드에 실패했습니다.');
        }
        this.isUploading = false;
      });
    } catch (error) {
      console.error('uploadFeedImages error:', error);
      toast.error('이미지 업로드 중 오류가 발생했습니다.');
      this.isUploading = false;
    }
  };

  @action
  fetchSnsFeed = async () => {
    if (this.isFetching) return;
    this.isFetching = true;
    try {
      const params = {
        store_id: this.store._id,
        shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      };
      await this.props.fetchAndUploadSnsFeed(params, (res) => {
        if (res && res.data && res.data.success) {
          toast.success(res.data.message);
          this.doSearch();
        } else {
          toast.error('피드 가져오기에 실패했습니다.');
        }
        this.isFetching = false;
      });
    } catch (error) {
      console.error('fetchSnsFeed error:', error);
      toast.error('피드 가져오기 중 오류가 발생했습니다.');
      this.isFetching = false;
    }
  };

  @action
  doSearch = async () => {
    let _this = this;
    _this.isLoading = true;

    // localStorage에 limit 값 저장
    Storage.set('limitSnsFeed', _this.listParams.limit);

    // 선택된 SNS의 연동 상태 확인
    if (!_this.snsData[_this.selectedSns] || !_this.snsData[_this.selectedSns].connected) {
      toast.warning(`${_this.getSnsLabel(_this.selectedSns)}가 연동되지 않았습니다. SNS 설정에서 연동해주세요.`);
      _this.list = { docs: [], totalDocs: 0, page: 1, totalPages: 1 };
      _this.isLoading = false;
      return;
    }

    // 공통 파라미터 설정
    let params = {
      store_id: _this.store._id,
      shopNo: _this.teamUser.selShopNo ? _this.teamUser.selShopNo : 1,
      page: _this.listParams.page,
      limit: _this.listParams.limit,
      sort: _this.listParams.sort,
      order: _this.listParams.order,
      sns: _this.selectedSns // 선택된 SNS로 필터링
    };

    // feedType 설정 (내 피드 vs 태그된 피드)
    if (_this.activeTab === 'taggedFeed') {
      params.feedType = 'tagged'; // 태그된 피드만
    } else {
      params.feedType = 'own'; // 본인이 직접 게시한 피드만
    }

    // 숨김 상태 필터
    if(_this.searchFormValue.isHidden !== 'all') {
      params.isHidden = _this.searchFormValue.isHidden === 'true';
    }

    // getSnsFeed API 공통 사용
    this.props.getSnsFeed(params, function(res) {
      console.log('SNS Feed Response:', res);
      if(res && res.docs) {
        _this.list = res;
      } else {
        _this.list = { docs: [], totalDocs: 0, page: 1, totalPages: 1 };
      }
      _this.isLoading = false;
    });
  };

  @action
  changeTab = async (tab) => {
    this.activeTab = tab;
    this.listParams.page = 1;
    this.nextCursor = null;
    this.hasNextPage = false;
    await this.doSearch();
  };

  @action
  onChangeSearchValue = async (event) => {
    const { name, value } = event.target;
    this.searchFormValue[name] = value;
  };

  @action
  onChangeSortOrder = async (event) => {
    const { name, value } = event.target;
    this.listParams[name] = value;
    this.listParams.page = 1;
    await this.doSearch();
  };

  getSnsIcon = (sns) => {
    const icons = {
      'instagram': 'instagram',
      'facebook': 'facebook',
      'naver': 'message-circle',
      'youtube': 'youtube'
    };
    return icons[sns] || 'share-2';
  };

  getSnsLabel = (sns) => {
    const labels = {
      'instagram': 'Instagram',
      'facebook': 'Facebook',
      'naver': '네이버',
      'youtube': 'YouTube'
    };
    return labels[sns] || sns;
  };

  @action
  toggleSelectAll = () => {
    if (this.isAllSelected) {
      this.selectedItems = [];
      this.isAllSelected = false;
    } else {
      this.selectedItems = this.list.docs.map(item => item.id || item._id);
      this.isAllSelected = true;
    }
  };

  @action
  toggleSelectItem = (itemId) => {
    const index = this.selectedItems.indexOf(itemId);
    if (index > -1) {
      this.selectedItems.splice(index, 1);
    } else {
      this.selectedItems.push(itemId);
    }
    this.isAllSelected = this.selectedItems.length === this.list.docs.length;
  };

  @action
  registerSelectedReviews = () => {
    if (this.selectedItems.length === 0) {
      toast.warning('선택된 피드가 없습니다.');
      return;
    }

    // 상품 선택 모달 열기
    this.showProductModal = true;
    this.getProductList();
  };

  @action
  getProductList = async () => {
    try {
      const params = {
        store_id: this.store._id,
        shopNo: this.teamUser.selShopNo,
        page: this.productSearchParams.page,
        limit: this.productSearchParams.limit,
        searchParams: {
          keyword: this.productSearchParams.keyword
        }
      };

      const result = await this.props.getProductList(params);
      if (result) {
        this.productList = result;
      }
    } catch (error) {
      console.error('상품 리스트 로드 실패:', error);
      toast.error('상품 리스트를 불러오는데 실패했습니다.');
    }
  };

  @action
  onChangeProductSearch = (event) => {
    const { name, value } = event.target;
    this.productSearchParams[name] = value;
  };

  @action
  searchProducts = () => {
    this.productSearchParams.page = 1;
    this.getProductList();
  };

  @action
  closeProductModal = () => {
    this.showProductModal = false;
    this.productSearchParams.keyword = '';
    this.productSearchParams.page = 1;
    this.reviewDateEnabled = false;
    this.reviewDate = moment().format('YYYY-MM-DD');
    this.reviewDefaultContent = '인스타그램에서 작성된 리뷰 입니다.';
    this.reviewSnsLabel = '인스타그램에서 작성된 리뷰 입니다.';
    this.reviewSnsLabelEnabled = true;
    this.reviewProductScore = 5;
    this.reviewDeliveryScore = 5;
  };

  @action
  selectProduct = async (product) => {
    if (this.selectedItems.length === 0) {
      toast.warning('선택된 피드가 없습니다.');
      return;
    }

    try {
      this.isLoading = true;

      const params = {
        store_id: this.store._id,
        shopNo: this.teamUser.selShopNo,
        snsFeed_Ids: this.selectedItems, // JSON 배열
        productNo: product.platformProductId, // 상품번호
        reviewDate: this.reviewDateEnabled ? this.reviewDate : '', // 리뷰 작성 날짜 (OFF면 피드 작성일 사용)
        reviewDefaultContent: this.reviewDefaultContent, // 리뷰 내용 기본값
        reviewSnsLabelEnabled: this.reviewSnsLabelEnabled, // SNS 리뷰 표시 활성화 여부
        reviewSnsLabel: this.reviewSnsLabelEnabled ? this.reviewSnsLabel : '', // SNS 리뷰 표시 (활성화 시 content 뒤에 붙임)
        reviewProductScore: this.reviewProductScore, // 상품별점
        reviewDeliveryScore: this.reviewDeliveryScore, // 배송별점
      };

      await this.props.registerSnsFeedsToReview(params, (res) => {
        console.log('Register SNS Feeds Response:', res);

        if (res && res.data && res.data.success) {
          toast.success(`${product.productName} 상품으로 ${res.data.message}`);

          // 모달 닫기 및 선택 초기화
          this.closeProductModal();
          this.selectedItems = [];
          this.isAllSelected = false;

          // 리스트 새로고침
          this.doSearch();
        } else {
          const errorMessage = res && res.data && res.data.message ? res.message.data : '리뷰 등록에 실패했습니다.';
          toast.error(errorMessage);
        }

        this.isLoading = false;
      });
    } catch (error) {
      console.error('Register SNS Feeds Error:', error);
      toast.error('리뷰 등록 중 오류가 발생했습니다.');
      this.isLoading = false;
    }
  };

  @action
  openMediaDetail = (media) => {
    console.log('Media Detail:', media);
    this.selectedMedia = media;
    this.showMediaModal = true;
  };

  @action
  closeMediaDetail = () => {
    this.selectedMedia = null;
    this.showMediaModal = false;
  };

  formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M';
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K';
    }
    return num;
  };

  formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString('ko-KR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  render() {
    let _this = this;

    function Pagination() {
      let result = [];
      let totalPages = _this.list.totalPages;
      let curPageNum = _this.list.page;
      let startNum = (parseInt((curPageNum-1)/10)*10) +1;
      let endNum = startNum+9 < totalPages ? startNum+9 : totalPages;

      let rendering = () => {
        for(let i = startNum; i <= endNum; i ++) {
          if(i === curPageNum) {
            result.push(<li key={i} className="on"><button type="button" className="sns-page-link" onClick={() => {
              _this.listParams.page = i;
              _this.doSearch();
            }}>{i}</button></li>);
          }
          else {
            result.push(<li key={i}><button type="button" className="sns-page-link" onClick={() => {
              _this.listParams.page = i;
              _this.doSearch();
            }}>{i}</button></li>);
          }
        }
        return result;
      }

      if(_this.list && _this.list.totalPages) {
        return (
            <div className="pagination">
              <ul>
                { curPageNum !== 1 ? <li className="btn-page-first"><button type="button" className="sns-page-link" onClick={() => {
                  _this.listParams.page = 1;
                  _this.doSearch();
                }}><FeatherIcon icon="chevrons-left" className="nd-icon" /></button></li> : null}
                { startNum - 1 > 0 ? <li className="btn-page-prev"><button type="button" className="sns-page-link" onClick={() => {
                  _this.listParams.page = startNum-1;
                  _this.doSearch();
                }}><FeatherIcon icon="chevron-left" className="nd-icon" /></button></li> : null}
                {rendering()}
                { endNum !== totalPages  ? <li className="btn-page-next"><button type="button" className="sns-page-link" onClick={() => {
                  _this.listParams.page = startNum+10;
                  _this.doSearch();
                }}><FeatherIcon icon="chevron-right" className="nd-icon" /></button></li> : null}
                { curPageNum !== totalPages ? <li className="btn-page-last"><button type="button" className="sns-page-link" onClick={() => {
                  _this.listParams.page = totalPages;
                  _this.doSearch();
                }}><FeatherIcon icon="chevrons-right" className="nd-icon" /></button></li> : null}
              </ul>
            </div>);
      }
      return null;
    }

    return (
      <div className="main-content">
        <ModalLoading show={this.isLoading} />

        <PageTitle />

        <Card className="mb-4">
          <CardBody>
            {/* SNS 플랫폼 선택 - 최상단 */}
            <Row className="mb-3">
              <Col>
                <div style={{display: 'flex', gap: '10px', borderBottom: '2px solid #e1e8ed', paddingBottom: '10px'}}>
                  <Button
                    theme={this.selectedSns === 'instagram' ? 'primary' : 'light'}
                    onClick={() => this.changeSns('instagram')}
                    disabled={!this.snsData.instagram.connected}
                  >
                    <FeatherIcon size="16" icon="instagram" />&nbsp;&nbsp;Instagram
                    {!this.snsData.instagram.connected && <Badge theme="danger" className="ml-2" style={{fontSize: '9px'}}>미연동</Badge>}
                  </Button>
                  <Button
                    theme={this.selectedSns === 'facebook' ? 'primary' : 'light'}
                    onClick={() => this.changeSns('facebook')}
                    disabled={!this.snsData.facebook.connected}
                  >
                    <FeatherIcon size="16" icon="facebook" />&nbsp;&nbsp;Facebook
                    {!this.snsData.facebook.connected && <Badge theme="danger" className="ml-2" style={{fontSize: '9px'}}>미연동</Badge>}
                  </Button>
                  <Button
                    theme={this.selectedSns === 'naver' ? 'primary' : 'light'}
                    onClick={() => this.changeSns('naver')}
                    disabled={!this.snsData.naver.connected}
                  >
                    <FeatherIcon size="16" icon="message-circle" />&nbsp;&nbsp;네이버
                    {!this.snsData.naver.connected && <Badge theme="danger" className="ml-2" style={{fontSize: '9px'}}>미연동</Badge>}
                  </Button>
                  <Button
                    theme={this.selectedSns === 'youtube' ? 'primary' : 'light'}
                    onClick={() => this.changeSns('youtube')}
                    disabled={!this.snsData.youtube.connected}
                  >
                    <FeatherIcon size="16" icon="youtube" />&nbsp;&nbsp;YouTube
                    {!this.snsData.youtube.connected && <Badge theme="danger" className="ml-2" style={{fontSize: '9px'}}>미연동</Badge>}
                  </Button>
                </div>
              </Col>
            </Row>

            {/* 탭 (Instagram만 태그된 피드 지원) */}
            {this.selectedSns === 'instagram' && (
              <Row className="mb-3">
                <Col>
                  <div style={{display: 'flex', gap: '10px', borderBottom: '1px solid #e1e8ed', paddingBottom: '10px'}}>
                    <Button
                      theme={this.activeTab === 'myFeed' ? 'primary' : 'light'}
                      size="sm"
                      onClick={() => this.changeTab('myFeed')}
                    >
                      <FeatherIcon size="16" icon="grid" />&nbsp;&nbsp;내 피드
                    </Button>
                    <Button
                      theme={this.activeTab === 'taggedFeed' ? 'primary' : 'light'}
                      size="sm"
                      onClick={() => this.changeTab('taggedFeed')}
                    >
                      <FeatherIcon size="16" icon="at-sign" />&nbsp;&nbsp;내가 태그된 피드
                    </Button>
                  </div>
                </Col>
              </Row>
            )}

            {/* 검색 필터 */}
            <Row className="mb-3">
              <Col md="2">
                <FormGroup>
                  <label>숨김 상태</label>
                  <FormSelect
                    name="isHidden"
                    value={this.searchFormValue.isHidden}
                    onChange={event => this.onChangeSearchValue(event)}
                  >
                    <option value="all">전체</option>
                    <option value="false">표시</option>
                    <option value="true">숨김</option>
                  </FormSelect>
                </FormGroup>
              </Col>
              <Col md="2">
                <FormGroup>
                  <label>정렬 기준</label>
                  <FormSelect
                    name="sort"
                    value={this.listParams.sort}
                    onChange={event => this.onChangeSortOrder(event)}
                  >
                    <option value="createdAt">생성일</option>
                    <option value="publishedAt">게시일</option>
                  </FormSelect>
                </FormGroup>
              </Col>
              <Col md="2">
                <FormGroup>
                  <label>정렬 순서</label>
                  <FormSelect
                    name="order"
                    value={this.listParams.order}
                    onChange={event => this.onChangeSortOrder(event)}
                  >
                    <option value="desc">최신순</option>
                    <option value="asc">오래된순</option>
                  </FormSelect>
                </FormGroup>
              </Col>
              <Col md="6" className="text-right d-flex align-items-end">
                <Button onClick={() => {
                  this.listParams.page = 1;
                  this.doSearch();
                }} style={{marginBottom: '15px'}}>
                  <FeatherIcon size="17" icon="search" className="nd-icon" />&nbsp;&nbsp;검색
                </Button>
              </Col>
            </Row>

            <div className="mb-3 d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center" style={{gap: '10px'}}>
                <strong>전체 {this.list.totalDocs}건</strong>
                {this.selectedItems.length > 0 && (
                  <span style={{color: '#007bff'}}>
                    (선택: <strong>{this.selectedItems.length}</strong>개)
                  </span>
                )}
              </div>
              <div className="d-flex align-items-center" style={{gap: '10px'}}>
                <select
                  name="limit"
                  value={this.listParams.limit}
                  onChange={event => {
                    this.listParams.limit = parseInt(event.target.value);
                    this.listParams.page = 1;
                    Storage.set('limitSnsFeed', event.target.value);
                    this.doSearch();
                  }}
                  style={{padding: '5px 10px', borderRadius: '4px', border: '1px solid #ddd'}}
                >
                  <option value="20">20개씩 보기</option>
                  <option value="50">50개씩 보기</option>
                  <option value="100">100개씩 보기</option>
                </select>
                <Button
                  theme="info"
                  onClick={() => this.fetchSnsFeed()}
                  disabled={this.isFetching}
                >
                  <FeatherIcon size="16" icon="download-cloud" />&nbsp;&nbsp;{this.isFetching ? '가져오는 중...' : '피드 가져오기'}
                </Button>
                <Button
                  theme="primary"
                  onClick={() => this.registerSelectedReviews()}
                  disabled={this.selectedItems.length === 0}
                >
                  <FeatherIcon size="16" icon="plus-circle" />&nbsp;&nbsp;리뷰 등록하기
                </Button>
              </div>
            </div>

            {this.getUnuploadedFeeds().length > 0 && (
              <div style={{
                padding: '12px 16px', marginBottom: '12px', borderRadius: '6px',
                background: '#fff8e1', border: '1px solid #ffe082',
                display: 'flex', justifyContent: 'space-between', alignItems: 'center'
              }}>
                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                  <FeatherIcon icon="alert-triangle" size="18" style={{color: '#f9a825'}} />
                  <span style={{fontSize: '13px', color: '#5d4037'}}>
                    현재 페이지에서 이미지가 카페24에 저장되지 않은 피드가 <strong>{this.getUnuploadedFeeds().length}건</strong> 있습니다. 시간이 지나면 이미지가 만료될 수 있습니다.
                  </span>
                </div>
                <Button
                  size="sm"
                  theme="warning"
                  onClick={() => this.uploadFeedImages()}
                  disabled={this.isUploading}
                  style={{whiteSpace: 'nowrap'}}
                >
                  <FeatherIcon size="14" icon="upload-cloud" />&nbsp;&nbsp;{this.isUploading ? '업로드 중...' : '카페24에 이미지 저장'}
                </Button>
              </div>
            )}

            <div className="review-list-table">
              <table>
                <colgroup>
                  <col width="3%" />
                  <col width="4%" />
                  <col width="8%" />
                  <col width="8%" />
                  <col width="10%" />
                  <col />
                  <col width="8%" />
                  <col width="8%" />
                  <col width="10%" />
                  <col width="6%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        checked={this.isAllSelected}
                        onChange={() => this.toggleSelectAll()}
                        style={{cursor: 'pointer'}}
                      />
                    </th>
                    <th>번호</th>
                    <th>SNS</th>
                    <th>피드타입</th>
                    <th>미디어</th>
                    <th>내용</th>
                    <th>반응</th>
                    <th>게시일</th>
                    <th>가져온시간</th>
                    <th>상태</th>
                  </tr>
                </thead>
                <tbody>
                  {this.list.docs && this.list.docs.length > 0 ? (
                    this.list.docs.map((item, i) => {
                      const itemId = item.id || item._id || `item-${i}`;
                      const isNotUploaded = this.isNotUploadedItem(item);
                      return (
                      <tr key={i}>
                        <td className="text-center">
                          <input
                            type="checkbox"
                            checked={this.selectedItems.includes(itemId)}
                            onChange={() => this.toggleSelectItem(itemId)}
                            disabled={isNotUploaded}
                            style={{cursor: isNotUploaded ? 'not-allowed' : 'pointer', opacity: isNotUploaded ? 0.4 : 1}}
                            title={isNotUploaded ? '이미지를 카페24에 먼저 저장해주세요' : ''}
                          />
                        </td>
                        <td className="text-center">{this.list.totalDocs - ((this.list.page - 1) * this.list.limit) - i}</td>
                        <td className="text-center">
                          <Badge theme="primary">
                            <FeatherIcon size="14" icon={this.getSnsIcon(item.sns || this.selectedSns)} />
                            &nbsp;{this.getSnsLabel(item.sns || this.selectedSns)}
                          </Badge>
                        </td>
                        <td className="text-center">
                          {(() => {
                            // Instagram API 직접 응답 (media_type) 처리
                            const mediaType = item.media_type || item.feedType;
                            const feedTypeLabels = {
                              'post': '포스트',
                              'image': '이미지',
                              'IMAGE': '이미지',
                              'video': '비디오',
                              'VIDEO': '비디오',
                              'carousel': '다중 이미지',
                              'CAROUSEL_ALBUM': '다중 이미지',
                              'story': '스토리',
                              'reel': '릴스'
                            };
                            const feedTypeThemes = {
                              'post': 'info',
                              'image': 'success',
                              'IMAGE': 'success',
                              'video': 'danger',
                              'VIDEO': 'danger',
                              'carousel': 'warning',
                              'CAROUSEL_ALBUM': 'warning',
                              'story': 'secondary',
                              'reel': 'primary'
                            };
                            return (
                              <Badge theme={feedTypeThemes[mediaType] || 'info'}>
                                {feedTypeLabels[mediaType] || mediaType || '-'}
                              </Badge>
                            );
                          })()}
                        </td>
                        <td className="text-center">
                          {(() => {
                            // 미디어 URL 찾기
                            let mediaUrl = null;
                            let mediaType = null;

                            // Instagram API 직접 응답 (media_url)
                            if (item.media_url) {
                              mediaUrl = item.media_url;
                              mediaType = item.media_type;
                            }
                            // 일반 SNS 피드 구조 (media 배열)
                            else if (item.media && Array.isArray(item.media) && item.media.length > 0) {
                              mediaUrl = item.media[0].thumbnailUrl || item.media[0].url;
                              mediaType = item.media[0].type;
                            }

                            return (
                              <div
                                style={{position: 'relative', display: 'inline-block', cursor: 'pointer'}}
                                onClick={() => this.openMediaDetail(item)}
                              >
                                {mediaUrl ? (
                                  <>
                                    <img
                                      src={mediaUrl}
                                      alt="SNS media"
                                      style={{width: '80px', height: '80px', objectFit: 'cover', borderRadius: '4px', border: isNotUploaded ? '2px solid #f9a825' : 'none'}}
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.style.display = 'none';
                                        e.target.parentElement.innerHTML = '<div style="width: 80px; height: 80px; background: #f5f5f5; border-radius: 4px; display: flex; align-items: center; justify-content: center; color: #ccc; font-size: 12px;">만료됨</div>';
                                      }}
                                    />
                                    {isNotUploaded && (
                                      <div style={{position: 'absolute', bottom: '-2px', left: '50%', transform: 'translateX(-50%)', background: '#f9a825', color: '#fff', fontSize: '9px', padding: '1px 5px', borderRadius: '3px', whiteSpace: 'nowrap'}}>
                                        미저장
                                      </div>
                                    )}
                                    {(mediaType === 'video' || mediaType === 'VIDEO') && (
                                      <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', background: 'rgba(0,0,0,0.6)', borderRadius: '50%', padding: '5px'}}>
                                        <FeatherIcon icon="play" size="20" color="white" />
                                      </div>
                                    )}
                                    {item.media && item.media.length > 1 && (
                                      <Badge theme="dark" style={{position: 'absolute', top: '5px', right: '5px', fontSize: '10px'}}>
                                        +{item.media.length - 1}
                                      </Badge>
                                    )}
                                  </>
                                ) : (
                                  <div style={{width: '80px', height: '80px', background: '#f5f5f5', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                    <FeatherIcon icon="image" size="24" color="#ccc" />
                                  </div>
                                )}
                              </div>
                            );
                          })()}
                        </td>
                        <td>
                          <div
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: 'vertical',
                              cursor: 'pointer'
                            }}
                            onClick={() => this.openMediaDetail(item)}
                          >
                            {(() => {
                              let text = '';

                              // Instagram API 직접 응답 (caption)
                              if (item.caption) {
                                text = item.caption;
                              }
                              // 일반 SNS 피드 구조 (content)
                              else if (item.content) {
                                if (typeof item.content === 'string') {
                                  text = item.content;
                                } else if (typeof item.content === 'object') {
                                  text = item.content.caption || item.content.text || '';
                                }
                              }

                              return text || '-';
                            })()}
                          </div>
                        </td>
                        <td className="text-center">
                          {(() => {
                            // Instagram API 직접 응답
                            if (item.like_count !== undefined || item.comments_count !== undefined) {
                              return (
                                <div style={{display: 'flex', flexDirection: 'column', gap: '3px', fontSize: '11px'}}>
                                  <div>
                                    <FeatherIcon icon="heart" size="12" /> {item.like_count || 0}
                                  </div>
                                  <div>
                                    <FeatherIcon icon="message-circle" size="12" /> {item.comments_count || 0}
                                  </div>
                                </div>
                              );
                            }
                            // 일반 SNS 피드 구조
                            else if (item.engagement) {
                              return (
                                <div style={{display: 'flex', flexDirection: 'column', gap: '3px', fontSize: '11px'}}>
                                  <div>
                                    <FeatherIcon icon="heart" size="12" /> {item.engagement.likeCount || 0}
                                  </div>
                                  <div>
                                    <FeatherIcon icon="message-circle" size="12" /> {item.engagement.commentCount || 0}
                                  </div>
                                </div>
                              );
                            }
                            return '-';
                          })()}
                        </td>
                        <td className="text-center">
                          {item.timestamp ? moment(item.timestamp).format('YYYY-MM-DD HH:mm') :
                           item.publishedAt ? moment(item.publishedAt).format('YYYY-MM-DD HH:mm') : '-'}
                        </td>
                        <td className="text-center">
                          {item.fetchedAt ? moment(item.fetchedAt).format('YYYY-MM-DD HH:mm') :
                           item.createdAt ? moment(item.createdAt).format('YYYY-MM-DD HH:mm') :
                           item.timestamp ? moment(item.timestamp).format('YYYY-MM-DD HH:mm') : '-'}
                        </td>
                        <td className="text-center">
                          {item.isHidden !== undefined ? (
                            item.isHidden ? (
                              <Badge theme="secondary">숨김</Badge>
                            ) : (
                              <Badge theme="success">표시</Badge>
                            )
                          ) : (
                            <Badge theme="info">-</Badge>
                          )}
                        </td>
                      </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="10" className="text-center">
                        SNS Feed가 없습니다.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <Pagination />
          </CardBody>
        </Card>

        {/* 피드 상세 모달 */}
        {this.showMediaModal && this.selectedMedia && (
          <div className="instagram-modal-overlay" onClick={this.closeMediaDetail}>
            <div className="instagram-modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close-btn" onClick={this.closeMediaDetail}>
                <FeatherIcon icon="x" size="24" />
              </button>
              <Row className="h-100">
                <Col lg="8" className="d-flex align-items-center justify-content-center bg-black">
                  {(() => {
                    // 미디어 URL 및 타입 찾기
                    let mediaUrl = null;
                    let mediaType = null;

                    // Instagram API 직접 응답
                    if (this.selectedMedia.media_url) {
                      mediaUrl = this.selectedMedia.media_url;
                      mediaType = this.selectedMedia.media_type;
                    }
                    // 일반 SNS 피드 구조
                    else if (this.selectedMedia.media && Array.isArray(this.selectedMedia.media) && this.selectedMedia.media.length > 0) {
                      mediaUrl = this.selectedMedia.media[0].url;
                      mediaType = this.selectedMedia.media[0].type;
                    }

                    if (mediaType === 'VIDEO' || mediaType === 'video') {
                      return (
                        <video
                          src={mediaUrl}
                          controls
                          className="modal-media"
                          autoPlay
                          style={{maxWidth: '100%', maxHeight: '100%'}}
                        />
                      );
                    } else {
                      return (
                        <img
                          src={mediaUrl}
                          alt="SNS post"
                          className="modal-media"
                          style={{maxWidth: '100%', maxHeight: '100%', objectFit: 'contain'}}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = '';
                            e.target.alt = '이미지가 만료되었습니다';
                            e.target.style.background = '#f5f5f5';
                            e.target.style.minHeight = '200px';
                            e.target.style.display = 'flex';
                          }}
                        />
                      );
                    }
                  })()}
                </Col>
                <Col lg="4" className="modal-sidebar" style={{background: 'white', overflowY: 'auto', padding: '20px'}}>
                  <div>
                    {/* SNS 플랫폼 정보 */}
                    <div className="d-flex align-items-center mb-3 pb-3" style={{borderBottom: '1px solid #e1e8ed'}}>
                      <Badge theme="primary" className="mr-2">
                        <FeatherIcon size="14" icon={this.getSnsIcon(this.selectedMedia.sns || this.selectedSns)} />
                        &nbsp;{this.getSnsLabel(this.selectedMedia.sns || this.selectedSns)}
                      </Badge>
                      {this.selectedMedia.username && (
                        <strong>@{this.selectedMedia.username}</strong>
                      )}
                    </div>

                    {/* 내용/캡션 */}
                    <div className="mb-3 pb-3" style={{borderBottom: '1px solid #e1e8ed'}}>
                      <p style={{whiteSpace: 'pre-wrap', wordBreak: 'break-word'}}>
                        {(() => {
                          let text = '';
                          // Instagram API 직접 응답 (caption)
                          if (this.selectedMedia.caption) {
                            text = this.selectedMedia.caption;
                          }
                          // 일반 SNS 피드 구조 (content)
                          else if (this.selectedMedia.content) {
                            if (typeof this.selectedMedia.content === 'string') {
                              text = this.selectedMedia.content;
                            } else if (typeof this.selectedMedia.content === 'object') {
                              text = this.selectedMedia.content.caption || this.selectedMedia.content.text || '';
                            }
                          }
                          return text || '내용 없음';
                        })()}
                      </p>
                    </div>

                    {/* 통계 정보 */}
                    <div className="media-info mb-3 pb-3" style={{borderBottom: '1px solid #e1e8ed'}}>
                      {(() => {
                        // Instagram API 직접 응답
                        if (this.selectedMedia.like_count !== undefined || this.selectedMedia.comments_count !== undefined) {
                          return (
                            <>
                              <div className="d-flex justify-content-between mb-2">
                                <span className="text-muted">
                                  <FeatherIcon icon="heart" size="16" /> 좋아요
                                </span>
                                <strong>{this.formatNumber(this.selectedMedia.like_count || 0)}</strong>
                              </div>
                              <div className="d-flex justify-content-between mb-2">
                                <span className="text-muted">
                                  <FeatherIcon icon="message-circle" size="16" /> 댓글
                                </span>
                                <strong>{this.formatNumber(this.selectedMedia.comments_count || 0)}</strong>
                              </div>
                            </>
                          );
                        }
                        // 일반 SNS 피드 구조
                        else if (this.selectedMedia.engagement) {
                          return (
                            <>
                              <div className="d-flex justify-content-between mb-2">
                                <span className="text-muted">
                                  <FeatherIcon icon="heart" size="16" /> 좋아요
                                </span>
                                <strong>{this.formatNumber(this.selectedMedia.engagement.likeCount || 0)}</strong>
                              </div>
                              <div className="d-flex justify-content-between mb-2">
                                <span className="text-muted">
                                  <FeatherIcon icon="message-circle" size="16" /> 댓글
                                </span>
                                <strong>{this.formatNumber(this.selectedMedia.engagement.commentCount || 0)}</strong>
                              </div>
                            </>
                          );
                        }
                        return null;
                      })()}
                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted">
                          <FeatherIcon icon="calendar" size="16" /> 게시일
                        </span>
                        <span>
                          {this.selectedMedia.timestamp
                            ? this.formatDate(this.selectedMedia.timestamp)
                            : this.selectedMedia.publishedAt
                            ? this.formatDate(this.selectedMedia.publishedAt)
                            : '-'}
                        </span>
                      </div>
                    </div>

                    {/* 원본 보기 버튼 */}
                    {this.selectedMedia.permalink && (
                      <div className="mt-4">
                        <Button
                          theme="primary"
                          block
                          onClick={() => window.open(this.selectedMedia.permalink, '_blank')}
                        >
                          <FeatherIcon icon="external-link" size="16" className="mr-1" />
                          {this.getSnsLabel(this.selectedMedia.sns || this.selectedSns)}에서 보기
                        </Button>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        )}

        {/* 상품 선택 모달 */}
        <Modal
          size="lg"
          open={this.showProductModal}
          toggle={() => this.closeProductModal()}
          style={{maxWidth: '1400px', width: '90%'}}
        >
          <ModalHeader>리뷰 등록하기</ModalHeader>
          <ModalBody>
            {/* 리뷰 설정 그룹 */}
            <div style={{border: '1px solid #E1E3E5', borderRadius: '8px', padding: '16px 20px', marginBottom: '16px', background: '#FAFBFB'}}>
              <div style={{fontSize: '14px', fontWeight: 600, color: '#202223', marginBottom: '12px'}}>리뷰 설정</div>
              <Row className="mb-3">
                <Col md="3">
                  <label style={{fontSize: '13px', fontWeight: 500, color: '#6D7175', marginBottom: '4px', display: 'block'}}>상품별점</label>
                  <FormSelect
                    value={this.reviewProductScore}
                    onChange={(e) => { this.reviewProductScore = parseInt(e.target.value); }}
                  >
                    <option value="5">5점</option>
                    <option value="4">4점</option>
                    <option value="3">3점</option>
                    <option value="2">2점</option>
                    <option value="1">1점</option>
                  </FormSelect>
                </Col>
                <Col md="3">
                  <label style={{fontSize: '13px', fontWeight: 500, color: '#6D7175', marginBottom: '4px', display: 'block'}}>배송별점</label>
                  <FormSelect
                    value={this.reviewDeliveryScore}
                    onChange={(e) => { this.reviewDeliveryScore = parseInt(e.target.value); }}
                  >
                    <option value="5">5점</option>
                    <option value="4">4점</option>
                    <option value="3">3점</option>
                    <option value="2">2점</option>
                    <option value="1">1점</option>
                  </FormSelect>
                </Col>
              </Row>
              <Row>
                <Col md="4">
                  <div style={{display: 'flex', alignItems: 'center', marginBottom: '4px'}}>
                    <label style={{fontSize: '13px', fontWeight: 500, color: '#6D7175', margin: 0}}>리뷰 작성 날짜</label>
                    <div
                      onClick={() => { this.reviewDateEnabled = !this.reviewDateEnabled; }}
                      style={{
                        width: '36px', height: '20px', borderRadius: '10px', marginLeft: '8px', cursor: 'pointer', position: 'relative', transition: 'background 0.2s',
                        background: this.reviewDateEnabled ? '#5C6AC4' : '#C4CDD5'
                      }}
                    >
                      <div style={{
                        width: '16px', height: '16px', borderRadius: '50%', background: '#fff', position: 'absolute', top: '2px', transition: 'left 0.2s',
                        left: this.reviewDateEnabled ? '18px' : '2px'
                      }} />
                    </div>
                    {!this.reviewDateEnabled && <span style={{fontSize: '11px', color: '#8C9196', marginLeft: '8px'}}>피드 작성일로 등록</span>}
                  </div>
                  <FormInput
                    type="date"
                    value={this.reviewDate}
                    onChange={(e) => { this.reviewDate = e.target.value; }}
                    disabled={!this.reviewDateEnabled}
                    style={{opacity: this.reviewDateEnabled ? 1 : 0.5}}
                  />
                </Col>
                <Col md="4">
                  <div style={{display: 'flex', alignItems: 'center', marginBottom: '4px'}}>
                    <label style={{fontSize: '13px', fontWeight: 500, color: '#6D7175', margin: 0}}>SNS 리뷰 표시</label>
                    <div
                      onClick={() => { this.reviewSnsLabelEnabled = !this.reviewSnsLabelEnabled; }}
                      style={{
                        width: '36px', height: '20px', borderRadius: '10px', marginLeft: '8px', cursor: 'pointer', position: 'relative', transition: 'background 0.2s',
                        background: this.reviewSnsLabelEnabled ? '#5C6AC4' : '#C4CDD5'
                      }}
                    >
                      <div style={{
                        width: '16px', height: '16px', borderRadius: '50%', background: '#fff', position: 'absolute', top: '2px', transition: 'left 0.2s',
                        left: this.reviewSnsLabelEnabled ? '18px' : '2px'
                      }} />
                    </div>
                  </div>
                  <FormInput
                    value={this.reviewSnsLabel}
                    onChange={(e) => { this.reviewSnsLabel = e.target.value; }}
                    placeholder="SNS 리뷰 표시 문구를 입력하세요"
                    disabled={!this.reviewSnsLabelEnabled}
                    style={{opacity: this.reviewSnsLabelEnabled ? 1 : 0.5}}
                  />
                </Col>
                <Col md="4">
                  <label style={{fontSize: '13px', fontWeight: 500, color: '#6D7175', marginBottom: '4px', display: 'block'}}>리뷰 내용 (내용이 없는 피드용)</label>
                  <FormInput
                    value={this.reviewDefaultContent}
                    onChange={(e) => { this.reviewDefaultContent = e.target.value; }}
                    placeholder="리뷰 내용을 입력하세요"
                    disabled={this.reviewSnsLabelEnabled}
                    style={{opacity: this.reviewSnsLabelEnabled ? 0.5 : 1}}
                  />
                </Col>
              </Row>
            </div>

            {/* 상품 검색 및 리스트 그룹 */}
            <div style={{border: '1px solid #E1E3E5', borderRadius: '8px', padding: '16px 20px', background: '#FFFFFF'}}>
              <div style={{fontSize: '14px', fontWeight: 600, color: '#202223', marginBottom: '12px'}}>리뷰를 추가할 상품을 선택해주세요</div>
              <div className="product-search-box mb-3">
                <Row>
                  <Col md="8">
                    <FormInput
                      name="keyword"
                      placeholder="상품명 또는 상품번호로 검색"
                      value={this.productSearchParams.keyword}
                      onChange={(e) => this.onChangeProductSearch(e)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          this.searchProducts();
                        }
                      }}
                    />
                  </Col>
                  <Col md="4">
                    <Button theme="primary" onClick={() => this.searchProducts()}>
                      <FeatherIcon size="16" icon="search" />&nbsp;&nbsp;검색
                    </Button>
                  </Col>
                </Row>
              </div>

              <div className="product-list-box">
              <div className="pick-list mb-2">
                <div className="pick-list-count">
                  검색결과 <span>{this.productList.totalDocs}</span>개
                </div>
                <div className="choice-num-view">
                  <select
                    name="limit"
                    value={this.productSearchParams.limit}
                    onChange={(e) => {
                      this.productSearchParams.limit = parseInt(e.target.value);
                      this.getProductList();
                    }}
                  >
                    <option value="20">20개씩 보기</option>
                    <option value="50">50개씩 보기</option>
                    <option value="100">100개씩 보기</option>
                  </select>
                </div>
              </div>

              <div style={{maxHeight: '750px', overflowY: 'auto'}}>
                <table className="table">
                  <colgroup>
                    <col width="88px" />
                    <col width="88px" />
                    <col />
                    <col width="20%" />
                    <col width="120px" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>상품번호</th>
                      <th>이미지</th>
                      <th>상품 이름</th>
                      <th>리뷰수</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.productList && this.productList.docs && this.productList.docs.length > 0 ? (
                      this.productList.docs.map((item, i) => (
                        <tr key={i}>
                          <td className="text-center">{item.platformProductId}</td>
                          <td className="text-center">
                            <div className="product-thumb" style={{width: '66px', height: '66px', margin: '0 auto'}}>
                              {item.images && item.images.s_1 ? (
                                <img src={item.images.s_1} alt={item.productName} style={{width: '100%', height: '100%', objectFit: 'cover'}} />
                              ) : (
                                <div style={{width: '100%', height: '100%', background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                  <FeatherIcon icon="image" size="24" color="#ccc" />
                                </div>
                              )}
                            </div>
                          </td>
                          <td>
                            <div className="product-title" style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: 'vertical'
                            }}>
                              {item.productName}
                            </div>
                            <div className="link-naverstore-search mt-1">
                              <a
                                href={`https://search.shopping.naver.com/search/all?query=${encodeURI(item.productName)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{fontSize: '11px', color: '#007bff'}}
                              >
                                네이버 스토어 검색
                              </a>
                            </div>
                          </td>
                          <td className="text-center">
                            {item.scoreInfo ? (
                              <div style={{fontSize: '13px'}}>
                                리뷰: {item.scoreInfo.reviewCount}<br />
                                평점: {item.scoreInfo.avgScore ? item.scoreInfo.avgScore.toFixed(1) : '-'}
                              </div>
                            ) : (
                              '-'
                            )}
                          </td>
                          <td className="text-center">
                            <Button
                              theme="success"
                              size="sm"
                              onClick={() => this.selectProduct(item)}
                            >
                              선택
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">
                          상품이 없습니다.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div className="text-center mt-3">
                <Button theme="light" onClick={() => this.closeProductModal()}>
                  닫기
                </Button>
              </div>
            </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default SnsFeed;
